import MainPagePresenter from "./MainPagePresenter";
import { Menu } from "nq-component";
import { getAllSchemasUseCase } from "../../usecases/schema/usecases";
import { getCurrentUserUseCase, signOutUseCase } from "../../usecases/user";
import { Routes, Route } from "react-router-dom";
import { OffCanvas } from "nq-component";
import CollectionListPage from "../collection-list/CollectionListPage";
import CollectionFormPage from "../collection-form/CollectionFormPage";
import BasePage from "../../base/BasePage";
import NotFoundPage from "../notfound";
import { Layout, Progress, LogoHolder } from "nq-component";
import MigrationPage from "../migration/MigrationPage";
import AccountPage from "../account/AccountPage";
import RoleFormPage from "../role-form/RoleFormPage";
import withRouter from "../../withRouter";
import HooksPage from "../web-hook/HooksPage";
import FunctionPage from "../web-hook/FunctionPage";
import SchemaPage from "../schema/SchemaPage";
import menus from "./menus.json";
import SaleTransPage from "../sales-and-transactions/SaleTransPage";
import GrossSalesPage from "../gross-sales/GrossSalesPage";
import TotalTransactionPage from "../total-transaction/TotalTransactionPage";
import TotalGuestPage from "../total-guest/TotalGuestPage";
import DiscountCostPage from "../discount-cost/DiscountCostPage";
import ProductsPage from "../products/ProductsPage";
import ItemSoldPage from "../products/chart/item-sold/ItemSoldPage";
import CustomerPage from "../customer/CustomerPage";
import ReportPage from "../report/ReportPage";
import ReportDashPage from "../report/ReportDashPage";
import { findObjectUseCase, getObjectUseCase } from "../../usecases/object";
import Top10ItemsPage from "../products/chart/top10-menu-items/Top10ItemsPage";
import LogsPage from "../logs/LogsPage";
import TransactionPage from "../transactions/TransactionPage";
import RawMaterialPage from "../food-cost/Item-master-list/raw-materials/list/RawMaterialPage";
import RawMaterialFormPage from "../food-cost/Item-master-list/raw-materials/form/RawMaterialFormPage";
import ComponentsPage from "../food-cost/Item-master-list/components/list/ComponentsPage";
import ComponentsFormPage from "../food-cost/Item-master-list/components/form/ComponentsFormPage";
import ProductPage from "../food-cost/Item-master-list/products/list/ProductPage";
import ProductFormPage from "../food-cost/Item-master-list/products/form/ProductFormPage";
import AuditLogsPage from "../food-cost/audit-logs/list/AuditLogsPage";
import InventoryPage from "../food-cost/inventory-management/inventory/list/InventoryPage";
import InventoryFormPage from "../food-cost/inventory-management/inventory/form/InventoryFormPage";
import InventoryLogsPage from "../food-cost/inventory-management/inventory-logs/list/InventoryLogsPage";
import PullOutPage from "../food-cost/pull-out-from-backup/list/PullOutPage";
import PullOutFormPage from "../food-cost/pull-out-from-backup/form/PullOutFormPage";
import DirectPurchacePage from "../food-cost/direct-purchase/list/DirectPurchacePage";
import DirectPurchaseFormPage from "../food-cost/direct-purchase/form/DirectPurchaseFormPage";
import StockRequestPage from "../food-cost/stock-transfer/stock-requests/list/StockRequestPage";
import StockRequestFormPage from "../food-cost/stock-transfer/stock-requests/form/StockRequestFormPage";
import TransferHistoryPage from "../food-cost/stock-transfer/transfer-history/list/TransferHistoryPage";
import TransferHistoryFormPage from "../food-cost/stock-transfer/transfer-history/form/TransferHistoryFormPage";
import UpcomingRequestPage from "../food-cost/stock-transfer/upcoming-requests/list/UpcomingRequestPage";
import UpcomingRequestFormPage from "../food-cost/stock-transfer/upcoming-requests/form/UpcomingRequestFormPage";
import PackagingBreakdownPage from "../food-cost/packaging-breakdown/list/PackagingBreakdownPage";
import PackagingBreakdownFormPage from "../food-cost/packaging-breakdown/form/PackagingBreakdownFormPage";
import ReceivableItemPage from "../food-cost/receivable-item/list/ReceivableItemPage";
import ReceivableItemFormPage from "../food-cost/receivable-item/form/ReceivableItemFormPage";
import WasteRawPage from "../food-cost/waste-management/waste-raw/list/WasteRawPage";
import WasteComponentPage from "../food-cost/waste-management/waste-component/list/WasteComponentPage";
import WasteProductPage from "../food-cost/waste-management/waste-product/list/WasteProductPage";
import ReportsPage from "../food-cost/reports/list/ReportsPage";
import ReceivableItemFormViewPage from "../food-cost/receivable-item/form/ReceivableItemFormViewPage";
import WasteRawFormPage from "../food-cost/waste-management/waste-raw/form/WasteRawFormPage";
import WasteComponentFormPage from "../food-cost/waste-management/waste-component/form/WasteComponentFormPage";
import WasteProductFormPage from "../food-cost/waste-management/waste-product/form/WasteProductFormPage";

class MainPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter(
      this,
      getCurrentUserUseCase(),
      findObjectUseCase(),
      signOutUseCase(),
      getAllSchemasUseCase(),
      getObjectUseCase()
    );
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  onClickSignOut() {
    this.presenter.onClickSignOut();
  }

  onClickMenu(e, item) {
    e.preventDefault();
    this.navigateTo(item.route);
  }

  filterAccess(menus, roles) {
    return menus.filter((menu) => {
      if (Array.isArray(menu.route)) {
        menu.route = this.filterAccess(menu.route, roles);
      }
      if (!menu.access) {
        return true;
      }
      if (roles.some((role) => menu.access.includes(role?.id))) {
        return true;
      }
      return false;
    });
  }

  render() {
    const user = this.getCurrentUser();
    const schemas = this.getSchemas();
    const roles = this.getCurrentRoles();
    const menu = [...menus];

    if (user === undefined || schemas === undefined) {
      return <Progress />;
    }

    return (
      <Layout>
        <Layout.Context.Consumer>
          {(value) => (
            <OffCanvas onSetShow={value.setCollapse} show={value.collapsed}>
              <div
                className="offcanvas-body p-0 gradient-background text-white"
                style={{
                  background:
                    "linear-gradient(to bottom, #1064ab, #1064ab 50%, #1064ab 50%)",
                }}
              >
                <nav className="">
                  <div className="text-center p-4">
                    <LogoHolder
                      className="bg-white"
                      textClassName="text-dark"
                      logo={user.picture}
                      name={user.username}
                    />
                    <p className="text-white mt-3">
                      {user.name || user.username}
                    </p>
                  </div>
                  <hr className="dropdown-divider bg-light" />
                  <div className="m-3">
                    <Menu
                      onClickItem={this.onClickMenu.bind(this)}
                      menus={this.filterAccess(menus, roles)}
                    />
                  </div>
                </nav>
              </div>
              <div className="" style={{ backgroundColor: "white" }}>
                <button
                  className="nav-link text-dark btn btn-link m-3"
                  onClick={this.onClickSignOut.bind(this)}
                >
                  <i className="bi bi-power"></i>
                  <span className="ms-2 fw-bold small">Log out</span>
                </button>
              </div>
            </OffCanvas>
          )}
        </Layout.Context.Consumer>
        <main className="vh-100 d-flex flex-column">
          <Routes>
            {/* <Route exact path={"/"} element={<DashboardPage />} /> */}
            {/*<Route*/}
            {/*  exact*/}
            {/*  path={"/collection/dashboard"}*/}
            {/*  element={<DashboardPage />}*/}
            {/*/>*/}
            {/* <Route path="/" element={}/> */}
            <Route
              exact
              path={"/collection/:name"}
              element={<CollectionListPage />}
            />
            <Route path={"/collection/roles/form"} element={<RoleFormPage />} />
            <Route
              path={"/collection/roles/form/:id"}
              element={<RoleFormPage />}
            />
            <Route
              path={"/collection/:name/form/"}
              element={<CollectionFormPage />}
            />
            <Route
              path={"/collection/:name/form/:id"}
              element={<CollectionFormPage />}
            />
            <Route path={"/migration"} element={<MigrationPage />} />
            <Route path={"/schema"} element={<SchemaPage />} />
            <Route path={"/account"} element={<AccountPage />} />
            <Route path={"/hooks"} element={<HooksPage />} />
            <Route path={"/function"} element={<FunctionPage />} />
            {/* start */}
            <Route path={"/sales&transactions"} element={<SaleTransPage />} />
            <Route path={"/grossSales"} element={<GrossSalesPage />} />
            <Route
              path={"/totalTransaction"}
              element={<TotalTransactionPage />}
            />
            <Route path={"/totalGuest"} element={<TotalGuestPage />} />
            <Route path={"/discountCost"} element={<DiscountCostPage />} />
            {/* productModule */}
            <Route path={"/products"} element={<ProductsPage />} />
            <Route path={"/itemSold"} element={<ItemSoldPage />} />
            <Route path={"/top10"} element={<Top10ItemsPage />} />
            {/* customerModule */}
            <Route path={"/customers"} element={<CustomerPage />} />
            {/* reportModule */}
            <Route path={"/report"} element={<ReportPage />} />
            <Route path={"/dashboard"} element={<ReportDashPage />} />
            <Route path={"/logs"} element={<LogsPage />} />
            {/* Transaction Route  */}
            <Route exact path={"/transactions"} element={<TransactionPage />} />
            {/* Food Cost Route */}
            <Route
              exact
              path={"/collection/raw_materials/list"}
              element={<RawMaterialPage />}
            />
            <Route
              exact
              path={"/collection/raw_material/form"}
              element={<RawMaterialFormPage />}
            />
            <Route
              exact
              path={"/collection/raw_material/form/:id"}
              element={<RawMaterialFormPage />}
            />
            <Route
              exact
              path={"/collection/components/list"}
              element={<ComponentsPage />}
            />
            <Route
              exact
              path={"/collection/component/form"}
              element={<ComponentsFormPage />}
            />
            <Route
              exact
              path={"/collection/component/form/:id"}
              element={<ComponentsFormPage />}
            />
            <Route
              exact
              path={"/collection/products/list"}
              element={<ProductPage />}
            />
            <Route
              exact
              path={"/collection/product/form"}
              element={<ProductFormPage />}
            />
            <Route
              exact
              path={"/collection/product/form/:id"}
              element={<ProductFormPage />}
            />
            <Route
              exact
              path={"/collection/audit_logs/list"}
              element={<AuditLogsPage />}
            />
            <Route
              exact
              path={"/collections/inventory/list"}
              element={<InventoryPage />}
            />
            <Route
              exact
              path={"/collection/inventory/form"}
              element={<InventoryFormPage />}
            />
            <Route
              exact
              path={"/collection/inventory/form/:id"}
              element={<InventoryFormPage />}
            />
            <Route
              exact
              path={"/collection/inventory_logs/list"}
              element={<InventoryLogsPage />}
            />
            <Route
              exact
              path={"/collection/backup_pullouts/list"}
              element={<PullOutPage />}
            />
            <Route
              exact
              path={"/collection/backup_pullouts/form"}
              element={<PullOutFormPage />}
            />
            <Route
              exact
              path={"/collection/backup_pullouts/form/:id"}
              element={<PullOutFormPage />}
            />
            <Route
              exact
              path={"/collection/backup_pullouts/form/view/:id"}
              element={<PullOutFormPage />}
            />
            {/* Direct Purchase Route */}
            <Route
              exact
              path={"/collection/direct_purchace/list"}
              element={<DirectPurchacePage />}
            />
            <Route
              exact
              path={"/collection/direct_purchaces/form"}
              element={<DirectPurchaseFormPage />}
            />
            <Route
              exact
              path={"/collection/direct_purchaces/form/:id"}
              element={<DirectPurchaseFormPage />}
            />
            {/* Stock Transfer Route */}
            <Route
              exact
              path={"/collection/stock_request/list"}
              element={<StockRequestPage />}
            />
            <Route
              exact
              path={"/collection/stock_request/form"}
              element={<StockRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/stock_request/form/:id/:view"}
              element={<StockRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/stock_request/form/:id/:reconcile"}
              element={<StockRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/stock_request/form/:id/:receive"}
              element={<StockRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/stock_request/form/:id/:partial"}
              element={<StockRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/stock_transfers/list"}
              element={<TransferHistoryPage />}
            />
            <Route
              exact
              path={"/collection/stock_transfers/form/:id"}
              element={<TransferHistoryFormPage />}
            />
            <Route
              exact
              path={"/collection/upcoming_request/list"}
              element={<UpcomingRequestPage />}
            />
            <Route
              exact
              path={"/collection/upcoming_request/form/:id"}
              element={<UpcomingRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/upcoming_request/form/:id/:approve"}
              element={<UpcomingRequestFormPage />}
            />
            {/* Packaging Route */}
            <Route
              exact
              path={"/collection/packaging_breakdown/list"}
              element={<PackagingBreakdownPage />}
            />
            <Route
              exact
              path={"/collection/packaging_breakdown/form"}
              element={<PackagingBreakdownFormPage />}
            />
            <Route
              exact
              path={"/collection/packaging_breakdown/form/:id"}
              element={<PackagingBreakdownFormPage />}
            />
            <Route
              exact
              path={"/collection/packaging_breakdown/form/:id/:view"}
              element={<PackagingBreakdownFormPage />}
            />
            {/* Receivable Route */}
            <Route
              exact
              path={"/collection/receivable_item/list"}
              element={<ReceivableItemPage />}
            />
            <Route
              exact
              path={"/collection/receivable_items/form"}
              element={<ReceivableItemFormPage />}
            />
            <Route
              exact
              path={"/collection/receivable_items/form/:id"}
              element={<ReceivableItemFormPage />}
            />
            <Route
              exact
              path={"/collection/receivable_items/form/:id/:view"}
              element={<ReceivableItemFormViewPage />}
            />
            {/* Waste Route */}
            <Route
              exact
              path={"/collection/waste_raw_materials/list"}
              element={<WasteRawPage />}
            />
            <Route
              exact
              path={"/collection/waste_raw_materials/form/:id/view"}
              element={<WasteRawFormPage />}
            />
            <Route
              exact
              path={"/collection/waste_components/list"}
              element={<WasteComponentPage />}
            />
            <Route
              exact
              path={"/collection/waste_components/form/:id/view"}
              element={<WasteComponentFormPage />}
            />
            <Route
              exact
              path={"/collection/waste_product/list"}
              element={<WasteProductPage />}
            />
            <Route
              exact
              path={"/collection/waste_product/form/:id/view"}
              element={<WasteProductFormPage />}
            />
            {/* Report Route */}
            <Route
              exact
              path={"/collection/report/list"}
              element={<ReportsPage />}
            />

            {/* <Route
              exact
              path={"/collection/inventory_logs/list"}
              element={<InventoryPage />}
            /> */}
            <Route element={<NotFoundPage />} />
          </Routes>
        </main>
      </Layout>
    );
  }
}

export default withRouter(MainPage);
